import { StoryData } from 'storyblok-js-client';

export const isStoryComponentType = (story: StoryData<any>, type: string) =>
  story.content.component === type;
